const messages = {
  'aboutUs.groupImgAltText': 'gruppo di Manos Sin Fonteras',
  'aboutUs.text': 'Questo blog è un’iniziativa di ',
  'aboutUs.textSecond': ', ed ha come obiettivo condividere conoscenze uniche ed esperienze che siano di ispirazione per la vita di tutti i giorni. ',
  'aboutUs.textThird': 'Ti invitiamo a conoscere differenti prospettive su temi come il benessere fisico e mentale, le emozioni e qualunque altro ti interessi.',
  'aboutUs.textFourth': 'Inoltre, condividiamo testimonianze che rivelano i benefici della Stimolazione Neurale e della meditazione, sul lavoro, gli studi, la famiglia o la vita personale.',
  'aboutUs.textFifth': 'Quindi rilassati e goditi ciascuno dei nostri articoli.',
  'aboutUs.copyright': 'Gli articoli presenti in questo blog sono di proprietà di Manos sin Fronteras.',
  'aboutUs.LJQuote': '“Ciò che non si condivide, si perde” – La Jardinera',
  'aboutUs.manos': 'Manos Sin Fronteras',

  'article.author': 'Scritto da: ',
  'article.contribute': 'Unisciti alla nostra rete di autori e condividi le tue conoscenze sulla nostra piattaforma ',

  'category.emptyQuery': 'Non abbiamo trovato nessun articolo',
  'category.mentalHealth': 'Benessere Mentale',
  'category.others': 'Altrui',
  'category.physicalWellbeing': 'Benessere Fisico',
  'category.selfawareness': 'Conoscenza di sé',
  'category.noMoreViolence': '#quellaVoltaChe',
  'category.reflections': 'Riflessioni',

  'categories.title': 'Categorie',

  'contact.name': 'Nome',
  'contact.email': 'email',
  'contact.message': 'Messagio',
  'contact.submit': 'Inviare',
  'contact.worldMap': 'MSF Nel Mondo',

  'contribute.altText': 'mano scrivendo - disegno',
  'contribute.text': 'Vuoi far parte del nostro team di collaboratori del blog? Perfetto, inviaci la tua testimonianza o il tuo articolo su un tema che ti appassioni.',
  'contribute.secondText': 'Le tue conoscenze e le tue esperienze sono la vita di questo blog.',
  'contribute.thirdText': 'Non preoccuparti se non sei forte a scrivere, siamo qui per aiutarti.',
  'contribute.join': 'Unisciti alla nostra rete di autori e sorprenditi a leggere il tuo messaggio nella nostra prossima newsletter!',
  'contribute.translation': 'Il nostro team si incaricherà di fare le traduzioni.',

  'footer.manos.label': 'MSF_int',
  'footer.manos.altText': 'Manos Sin Fronteras',
  'footer.yoMedito.label': 'Io Medito',
  'footer.yoMedito.altText': 'Palloncino monocromatico',
  'footer.laJardinera.label': 'La Jardinera',
  'footer.laJardinera.altText': 'Fiore monocromatico',
  'footer.copyright': '© 2018 Manos Sin Fronteras',

  'legal.address.label': 'Sede Legale',
  'legal.address.line1': 'Manos Sin Fronteras Internacionales',
  'legal.address.line2': 'C/ Ribargorza no. 18',
  'legal.address.line3': 'Entresuelo B de Zaragoza',
  'legal.address.line4': '50003 (Zaragoza)',
  'legal.contact.email': 'Indirizzo di posta elettronica: ',
  'legal.contact.phone': 'Telefono: +34 658 77 46 78',
  'legal.contact.website': 'Sito Web: ',
  'legal.representative.label': 'Rappresentante Legale',
  'legal.representative.name': 'Lucía Peña',
  'legal.representative.with': 'Registro: Diputación General de Aragón',
  'legal.representative.number': 'Numero di Registro: 01-Z-2070-2007',
  'legal.representative.code': 'Codice di identificazione Fiscale – P.IVA: G99197394',
  'legal.disclaimer.label': 'Dichiarazione Legale',
  'legal.disclaimer.text': 'Il contenuto di questo sito web è basato sulle leggi della Spagna, salvo indicazione espressa del contrario. Le opinioni e criteri pubblicati negli articoli rappresentano quelli dei rispettivi autori, e non del Blog di Manos Sin Fronteras Internacionales ed i suoi creatori. Se si vuole fare qualche suggerimento o porre un reclamo in relazione a quanto qui pubblicato, vi preghiamo di scriverci nella sezione Contatti. Abbiamo pubblicato gli articoli previ consenso espresso dei rispettivi autori.',

  'locale.en': 'English',
  'locale.es': 'Español',
  'locale.it': 'Italiano',
  'locale.pt': 'Português',

  'meta.description.aboutUs': 'Siamo Manos Sin Fronteras ed abbiamo creato questo blog per condividere conoscenza, esperienze, ed anche testimonianze sui benefici della Stimolazione Neurale. Tutto ciò affinchè sia fonte di ispirazione per la vita di tutti i giorni. ',
  'meta.description.contactUs': 'Vuoi condividere ciò che sai o la tua esperienza? Vuoi commentare gli articoli che pubblichiamo? Scrivici un messaggio e ti risponderemo subito.',
  'meta.description.contribute': 'Ti invitiamo a raccontare ai nostri lettori il tema che ti appassiona o le esperienze che sono state fondamentali per la tua crescita personale. La condivisione è la vita di questo blog! ',
  'meta.description.home': 'Benvenuti al Blog di Manos Sin Fronteras! Ti invitiamo a leggere i nostri articoli sul benessere físico, la salute e la crescita personale. ',
  'meta.description.mentalHealth': 'leggi articoli che parlano di come affrontare in modo sano situazioni complicate e tensioni. Sono i racconti di vita dei nostri autori. Scopri come sono arrivati a recuperare l’equilibrio mentale ed emotivo. ',
  'meta.description.others': 'In questa pagina troverai articoli interessanti su svariati temi che non rientrano nelle altre sezioni.',
  'meta.description.physicalWellbeing': 'Qui troverai articoli che parlano di come creare abitudini che possono migliorare il tuo benessere físico, ed il vincolo che lega le emozioni, la mente ed il corpo.',
  'meta.description.selfawareness': 'Scopri come la meditazione, la Stimolazione Neuronale o viaggi speciali hanno accelerato l\'autocoscienza in persone diverse e le loro esperienze in questo viaggio per conoscersi meglio',
  'meta.description.noMoreViolence': 'Inalo, esalo e riprendo possesso della mia vita, 5 minuti per la nostra voce',

  'menu.aboutUs': 'Chi Siamo',
  'menu.contactUs': 'Contattaci',
  'menu.contribute': 'Contribuisci',
  'menu.home': 'Home',
  'menu.legal': 'Informazioni Legali',

  'sidePanel.estimulacionNeural.altText': 'Stimolazione Neurale',
  'sidePanel.estimulacionNeural.text': 'Una tecnica per il tuo benessere físico, mentale ed emozionale. ',
  'sidePanel.estimulacionNeural.title': 'Stimolazione Neurale',
  'sidePanel.laJardinera.altText': 'Fiore Rosa',
  'sidePanel.laJardinera.text': 'Precorritrice della Stimolazione Neurale, ha dedicato la sua vita ad aiutare il Pianeta.',
  'sidePanel.laJardinera.title': 'La Jardinera',
  'sidePanel.yoMedito.altText': 'palloncino - Io Medito ',
  'sidePanel.yoMedito.text': 'Quando tu sei in pace, il mondo è in pace.',
  'sidePanel.yoMedito.title': 'Io Medito',

  'template.comments': 'Lascia un commento',
};

export default messages;
